/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const customFieldValueInputSchema = z.object({
  description: z.string().nullish(),
  value: z.union([z.boolean(), z.string(), z.number()]).nullish(),
});
